import React from 'react';
export function Footer() {
  return <footer className="bg-ink px-4 py-5 text-center sm:px-6" data-id="element-64" data-mp="32wd2qgad7ltj">
      <p className="font-heading text-[0.72rem] font-bold uppercase text-white/90" data-id="element-65" data-mp="3gfiuujlrgden">
        © 2026 OPHTHALMOLOGY VISUAL ATLAS™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1.5 max-w-2xl text-[0.68rem] leading-snug text-white/55 sm:text-xs" data-id="element-66" data-mp="32m1d94cmxar9">
        OPHTHALMOLOGY VISUAL ATLAS™ provides professional visual study and
        reference resources for ophthalmology. It does not replace required
        professional training, clinical evaluation, medical advice, diagnostic
        judgment, professional supervision or applicable clinical guidelines.
      </p>
      <p className="mt-1.5 text-[0.68rem] text-white/70 sm:text-xs" data-id="element-67" data-mp="3qd6qdbr6xoxv">
        Terms &amp; Conditions • Privacy Policy • Contact
      </p>
      <p className="mt-0.5 text-[0.68rem] text-white/70 sm:text-xs" data-id="element-68" data-mp="29yduzvyu6w7s">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="underline" data-id="element-69" data-mp="2ezbag0sgpc5l">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}